export enum InboundTaskDocumentStatusEnum {
  QUEUE = 'queue',
  IN_PROGRESS = 'in-progress',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
}

export enum InboundTaskItemStatusEnum {
  QUEUE = 'queue',
  ASSIGNED = 'assigned',
  RECEIVING = 'receiving',
  RECEIVED = 'received',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  CANCELLED = 'cancelled',
}

export enum InboundNSIntegrationStatusEnum {
  RECEIVING = 'receiving',
  WAITING_APPROVAL = 'waiting-approval',
  NS_SENDING = 'ns-sending',
  NS_COMPLETED = 'ns-completed',
  NS_FAILED = 'ns-failed',
  CANCELLED = 'cancelled',
}
